import { http } from '../services';

class ProjetoStatusFinalService {
    async getProjetosClassificacao(tipoApresentacao, subevento, area) {
        return http.get('/projeto-status-final', {
            tipoApresentacao,
            subevento,
            area,
        });
    }

    trabalhosPorSalaURL(sala, evento, area) {
        return http.getUrl('/relatorio-trabalhos-por-sala')
            +
            http.getParamsString({
                sala,
                evento,
                area,
            });
    }

    fichaAvaliacaoPorSalaURL(sala, evento, area) {
        return http.getUrl('/relatorio-ficha-avaliacao-por-sala')
            +
            http.getParamsString({
                sala,
                evento,
                area,
            });
    }
}

const projetoStatusFinalService = new ProjetoStatusFinalService();
export default projetoStatusFinalService;
